












































import { Vue, Component, Prop } from 'vue-property-decorator';
import CategoryBlockItem from './CategoryBlockItem.vue';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import CategoryTileBlockItem from '@/project/app/blocks/categories/CategoryTileBlockItem.vue';
import { CategoryTileBlockViewModel } from '@/types/contentServerContract';
import { IResponsiveImageWidthOnScreenConfig } from '@/core/responsive/image/ResponsiveImage.vue';
export enum CategoryTileBlockImageModes {
    'clipped',
    'lowFull',
    'highFull'
}
@Component({
    components: { CategoryTileBlockItem, CategoryBlockItem, SmartHeadline }
})
export default class CategoryTileBlock extends Vue {
    @Prop()
    content!: CategoryTileBlockViewModel;

    @Prop({
        required: false,
        default: false,
        type: Boolean
    }) isFirstBlock!: boolean;

    get imageMode() {
        return CategoryTileBlockImageModes[this.content.imageMode];
    }

    get classes() {
        const cls: string[] = [];
        if (this.imageMode !== CategoryTileBlockImageModes.clipped) {
            cls.push('category-tile-blocks--1-in-row-mobile');
        }
        if (this.content.tiles.length % 4 === 0) {
            cls.push('category-tile-blocks--4-in-row');
        } else if (this.content.tiles.length % 5 === 0) {
            cls.push('category-tile-blocks--5-in-row');
        }
        return cls;
    }

    get maxImageClippedDimension(): undefined | { width: number, height: number } {
        if (this.imageMode === CategoryTileBlockImageModes.clipped) {
            return { width: 100, height: 100 };
        }
        return undefined;
    }

    get imageSizesAttributes(): IResponsiveImageWidthOnScreenConfig | number {
        const maxItemsOnMdScreen = this.content.tiles.length > 5 ? this.content.tiles.length % 4 === 0 ? 4 : 3 : this.content.tiles.length % 5 === 0 ? 5 : 3;
        const numbers = {
            xs: 50,
            md: Math.floor(100 / (this.content.tiles.length % 4 === 0 ? 4 : maxItemsOnMdScreen))
        };
        return numbers;
    }

    get id() {
        return 'category-tile-block-' + new Date().valueOf();
    }

    get prevButtonSelector() {
        return 'custom-swiper-button-prev-' + this.id;
    }

    get nextButtonSelector() {
        return 'custom-swiper-button-next-' + this.id;
    }

    get sliderOptions() {
        return {
            spaceBetween: 20,
            slidesPerView: 2,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: '.' + this.nextButtonSelector,
                prevEl: '.' + this.prevButtonSelector
            },
            grabCursor: true,
            instanceName: this.id,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            breakpointsInverse: true, // Mobile first, then override on larger screens
            breakpoints: {
                640: {
                    slidesPerView: this.content.tiles.length % 4 === 0 ? 4 : 3
                }
            }
        };
    }
}
